export const DEFAULT_TABLE_ROWS_PER_PAGE = 10

export const TABLE_ROWS_PER_PAGE_OPTIONS = [5, 10, 25, 50]

export const ADVERTISEMENT_SEARCH_PER_PAGE = 24
